import React, { useCallback, useEffect, useContext, useState } from "react";

import { ToolContext, DONATION_LEVEL_STEP, DONOR_INFO_STEP, PAYMENT_STEP, RECEIPT_STEP } from "./ToolProvider";
import * as UI from "./ui";

const GuideStep = ({ currentStep, thisStep, setStep, name, max}) => {
  const onClick = () => {
    if(thisStep <= max) {
      setStep(thisStep)
    }
  };

  return (
    <UI.GuideStep active={currentStep === thisStep} onClick={onClick}>
      <UI.GuideStepArrow />
      {name}
    </UI.GuideStep>
  )
}

const Guide = () => {
  const { mode, step, setStep, expired } = useContext(ToolContext);
  const [ max, setMax ] = useState(0);

  const handleStepChange = useCallback((newStep) => {
    if (newStep > step) {
      return;
    }

    setStep(newStep);
  }, [step]);

  useEffect(() => {
    if(step > max) {
      setMax(step);
    }
  }, [max, step]);

  if(step === RECEIPT_STEP || expired) {
    return null;
  }

  return (
    <UI.Guide>
      <GuideStep
        currentStep={step}
        thisStep={DONATION_LEVEL_STEP}
        setStep={handleStepChange}
        name="Donation"
        max={max}
      />

      { mode === "mobile" && (
        <GuideStep
          currentStep={step}
          thisStep={DONOR_INFO_STEP}
          setStep={handleStepChange}
          name="Your Info"
          max={max}
        />
      )}

      <GuideStep
        currentStep={step}
        thisStep={PAYMENT_STEP}
        setStep={handleStepChange}
        name="Review & Pay"
        max={max}
      />
    </UI.Guide>
  );
}

export default Guide;
